export const FETCH_NGOS_REQUEST = 'FETCH_NGOS_REQUEST';
export const FETCH_NGOS_SUCCESS = 'FETCH_NGOS_SUCCESS';
export const FETCH_NGOS_FAIL = 'FETCH_NGOS_FAIL';
